export default "__VITE_ASSET__9ed67b19__"